import { ProgressBar } from '@tryhackme/thm-ui-components';
import { useGetCurrentPathQuery } from 'src/features/dashboard/components/continue-learning/continue-learning.slice';
import type { RoomDetailsData } from 'src/features/room/room.types';
import { StyledPathProgressWrapper, StyledProgressWrapper, StyledWrapperContent } from '../../../completion-modal.styles';
import { RoomStepProgress } from '../../room-step-progress';
export const PathProgress = ({
  currentRoom,
  isCompletionModal
}: {
  currentRoom?: RoomDetailsData;
  isCompletionModal?: boolean;
}) => {
  const {
    nextRoom
  } = currentRoom || {};
  const {
    data: pathProgress
  } = useGetCurrentPathQuery();
  return <StyledWrapperContent data-sentry-element="StyledWrapperContent" data-sentry-component="PathProgress" data-sentry-source-file="path-progress.tsx">
      <h2>Continue your learning</h2>
      <StyledPathProgressWrapper data-sentry-element="StyledPathProgressWrapper" data-sentry-source-file="path-progress.tsx">
        <p>You are currently enrolled in the {pathProgress?.data?.path?.title} learning path</p>
        {pathProgress && <StyledProgressWrapper>
            Progress:
            <ProgressBar value={pathProgress?.data?.progress ?? 0} max={100} />
            <span>{pathProgress?.data?.progress ?? 0}%</span>
          </StyledProgressWrapper>}
      </StyledPathProgressWrapper>
      {nextRoom && currentRoom && <RoomStepProgress nextRoom={nextRoom} currentRoom={currentRoom} isCompletionModal={isCompletionModal} />}
    </StyledWrapperContent>;
};